export { AddEdit };

function AddEdit() {
    // const mealPlan = useSelector(x => x.mealPlans?.item);
    // const dispatch = useDispatch();

    // const { id } = useParams();
    // const [title, setTitle] = useState(); 

    return (
        <>
        <p>Edit List</p>
        </>
    );
}